const decimal = (value) => value === null || value === undefined ? "" : Number(value).toFixed(2);
const csvCell = (value, protectFormula = true) => {
  const text = String(value ?? "");
  const safe = protectFormula && /^[\s]*[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};

export const createReportCsv = (rows) => {
  const headers = ["Prop-unit-tenant", "Tenant", "Address", "End Balance", "Rent outstanding", "Monthly rent",
    "Outstanding / rent", "Past rent due", "Past rent amount", "Last download amount",
    "Last downloaded", "Downloaded this month"];
  const records = rows.map((row) => [
    `${row.prop}-${row.unit}-${row.tenant}`, row.tenantName, row.address,
    decimal(row.endBalance), decimal(row.amount), decimal(row.rent), row.ratio == null ? "" : `${decimal(row.ratio)}%`,
    row.pastDue ? "Yes" : "No", decimal(row.pastDueAmount), decimal(row.lastDownloadAmount),
    row.lastDownloadTime, row.downloadedThisMonth ? "Yes" : "No",
  ]);
  // Generated numeric cells retain negative values; user-provided text still receives formula protection.
  const numericColumns = new Set([3, 4, 5, 6, 8, 9]);
  return "\uFEFF" + [headers.map((value) => csvCell(value)).join(","),
    ...records.map((record) => record.map((value, index) => csvCell(value, !numericColumns.has(index))).join(","))]
    .join("\r\n") + "\r\n";
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
